import { GAEventIdentifier, GAEventName } from '../constants';
import { isValidString, isValidArray } from './stringUtils';

const GA_FILTER_CONFIG = {
  search: {
    event: GAEventName.searchSubmit,
    identifier: GAEventIdentifier.searchBox,
    isValid: isValidString,
    format: (v: any) => v
  },
  amazonasin: {
    event: GAEventName.filterASIN,
    identifier: GAEventIdentifier.filterASIN,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  genres: {
    event: GAEventName.filterGenres,
    identifier: GAEventIdentifier.filterGenres,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  fiction_tags: {
    event: GAEventName.filterGenres,
    identifier: GAEventIdentifier.filterGenres,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  tag: {
    event: GAEventName.filterTags,
    identifier: GAEventIdentifier.filterTags,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  warning_tags: {
    event: GAEventName.filterTags,
    identifier: GAEventIdentifier.filterTags,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  not_tag: {
    event: GAEventName.filterTags,
    identifier: GAEventIdentifier.filterTags,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  not_warning_tags: {
    event: GAEventName.filterTags,
    identifier: GAEventIdentifier.filterTags,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  },
  days_tracked: {
    event: GAEventName.filterDaysTracked,
    identifier: GAEventIdentifier.filterDaysTracked,
    isValid: isValidString,
    format: (v: any) => v
  },
  late_bloomer: {
    event: GAEventName.filterAllTitles,
    identifier: GAEventIdentifier.filterAllTitles,
    isValid: isValidString,
    format: (v: any) => v
  },
  type_tag: {
    event: GAEventName.filterTypesTag,
    identifier: GAEventIdentifier.filterTypesTag,
    isValid: isValidString,
    format: (v: any) => v
  },
  status_tag: {
    event: GAEventName.filterStatusTag,
    identifier: GAEventIdentifier.filterStatusTag,
    isValid: isValidArray,
    format: (v: any[]) => v.join(', ')
  }
};

const sendGAFilterEvent = (a: any, sourcePath: string, tabId: string) => {
  const filterKey = Object.keys(a)[0];

  if (!filterKey) {
    return;
  }

  const source = sourcePath.replace('/', '');
  const rawKey = filterKey.replace(tabId, '');
  const config = GA_FILTER_CONFIG[rawKey as keyof typeof GA_FILTER_CONFIG];

  if (!config) {
    return;
  }

  const value = a[filterKey];

  if (!value || !config.isValid(value)) {
    return;
  }

  globalThis.gtag?.('event', config.event, {
    identifier: config.identifier,
    value: config.format(value),
    event_category: tabId,
    page_source: source
  });
};

export default sendGAFilterEvent;
